import * as types from './generalActionTypes.js';

// export const setBreakdownDetectedDialogOpen = (breakdownDetectedDialogOpen) => ({ type: types.SET_BREAKDOWNDETECTEDDIALOGOPEN, breakdownDetectedDialogOpen: breakdownDetectedDialogOpen });
export const setStoppedLine = (stoppedLine) => ({ type: types.SET_STOPPEDLINE, stoppedLine: stoppedLine });
export const setHelpFilesDialogOpen = (helpFilesDialogOpen) => ({ type: types.SET_HELPFILESDIALOGOPEN, helpFilesDialogOpen: helpFilesDialogOpen });
export const setScaleData = (scaleData) => ({ type: types.SET_SCALEDATA, scaleData: scaleData });
export const setPermissions = (permissionData) => ({ type: types.SET_PERMISSIONS, permissionData: permissionData });
export const setSystemParameters = (systemParameters) => ({ type: types.SET_SYSTEMPARAMETERS, systemParameters: systemParameters });


